var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 6.25V11.25C19.5 11.6875 19.1562 12 18.75 12H13.75C13.3125 12 13 11.6875 13 11.25C13 10.8438 13.3125 10.5 13.75 10.5H16.875C15.9375 8.71875 14.0625 7.5 12 7.5C8.9375 7.5 6.5 9.96875 6.5 13C6.5 16.0625 8.9375 18.5 12 18.5C13.2812 18.5 14.5312 18.0625 15.5 17.25C15.8125 16.9688 16.2812 17.0312 16.5625 17.3438C16.8125 17.6562 16.7812 18.125 16.4688 18.4062C15.2188 19.4375 13.625 20 11.9688 20C8.125 20 5 16.875 5 13C5 9.15625 8.125 6.03125 11.9688 6.03125C14.4688 6.03125 16.75 7.375 18 9.4375V6.25C18 5.84375 18.3125 5.5 18.75 5.5C19.1562 5.5 19.5 5.84375 19.5 6.25Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateRight);
export default __webpack_public_path__ + "static/media/RotateRight.d544a1a917fb098902bf0bd63e5586c9.svg";
export { ForwardRef as ReactComponent };